import generateRender from '../../../utils/generateRender';
export var buyButtonWithGradient = generateRender({
  default: false
});